var map = {
	"./de.json": 204489,
	"./en.json": 885973,
	"./es.json": 203003,
	"./fr.json": 901504,
	"./it.json": 831034,
	"./ja.json": 167788,
	"./ko.json": 436719,
	"./pl.json": 844940,
	"./pt.json": 198717,
	"./ru.json": 174108,
	"./uk.json": 644422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100986;